// Schema-type picker options for the Schema Markup plug-in.
//
// TYPE_TRANSLATIONS : the Danish label shown in the picker for each schema.org @type.
// ROOT_TYPES        : which types appear in the picker, in display order.
//
// To add / remove / reorder options, edit both structures below.
// To rename a label, change its value in TYPE_TRANSLATIONS.
// The KEYS are schema.org @type names written verbatim into the JSON-LD "@type",
// so they must match schema.org exactly - only edit the label (the value).
//
// NOTE: each type also needs a field template in SchemaMarkup.mapping.js so the
// correct fields render when that type is selected.

export const TYPE_TRANSLATIONS = {
    // Page / article level
    MedicalWebPage: "Medicinsk webside",
    MedicalScholarlyArticle: "Videnskabelig artikel",

    // Disease / anatomy / symptoms
    MedicalCondition: "Medicinsk tilstand",
    AnatomicalStructure: "Anatomisk struktur",
    MedicalSignOrSymptom: "Symptom eller tegn",
    MedicalRiskFactor: "Risikofaktor",

    // Diagnostics
    MedicalTest: "Medicinsk undersøgelse",

    // Treatment
    MedicalTherapy: "Behandling",
    MedicalProcedure: "Medicinsk procedure",
    Drug: "Lægemiddel",

    // Evidence / research
    MedicalGuideline: "Medicinsk retningslinje",
    MedicalStudy: "Medicinsk studie",

    // Prevention / nutrition
    DietarySupplement: "Kosttilskud",
    Diet: "Diæt / kostråd",
    Recipe: "Opskrift",

    // Care providers
    Hospital: "Hospital",
    MedicalClinic: "Klinik / behandlingssted",

    // Q&A
    FAQPage: "Ofte stillede spørgsmål"
}

export const ROOT_TYPES = [
    "MedicalWebPage",
    "MedicalScholarlyArticle",
    "MedicalCondition",
    "AnatomicalStructure",
    "MedicalSignOrSymptom",
    "MedicalRiskFactor",
    "MedicalTest",
    "MedicalTherapy",
    "MedicalProcedure",
    "Drug",
    "MedicalGuideline",
    "MedicalStudy",
    "DietarySupplement",
    "Diet",
    "Recipe",
    "Hospital",
    "MedicalClinic",
    "FAQPage"
]

export function translateType(type) {
    return TYPE_TRANSLATIONS[type] || type
}

export function typeOptions(current, base = ROOT_TYPES) {
    const values = !current || base.includes(current) ? base.slice() : [current, ...base]
    return values.map((value) => ({ label: translateType(value), value }))
}
